import * as React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import * as EventActions from '../actions/Event';
import * as ProfileActions from '../actions/Profile';
import * as CompanyActions from '../actions/Company';

import {Box, Button} from '@material-ui/core';

import CompanyGridList from '../components/event/CompanyGridList';
import Typography from '@material-ui/core/Typography';
import EventHeader from '../components/event/EventHeader';
import Title from 'reactjs-title'
import config from '../../shared/config';
import MyAccountDialog from '../components/MyAccountDialog';
import CompanyAppBar from '../components/company/CompanyAppBar';
import ResumeUploadNudge from '../components/ResumeUploadNudge';

class LobbyPage extends React.Component {

  async componentDidMount() {
    console.log("Loading Event with id", config.eventId);
    this.props.setEventId(config.eventId);
    await this.props.loadProfile();
    await this.props.checkIn(config.eventId);
  }

  render() {
    return (
      <Box>
        <MyAccountDialog open={this.props.accountDialogOpen}
          onClose={this.props.hideMyAccount}
          onSave={this.props.saveAccountDialog}
          formProps={this.props}
          onSubmit={this.props.submitAccountDialog}
          inProgress={this.props.profileInProgress}
        />

        <Title render={`${this.props.eventTitle} - ${this.props.eventSubtitle}`} />
        <EventHeader {...this.props} />

        <CompanyAppBar
          title=""
          onLogout={this.props.logout}
          onMyAccount={this.props.showMyAccount}
          profile={this.props.profile}>
          { this.props.resumePresent ? <div style={{flexGrow: 1}}>&nbsp;</div> : <ResumeUploadNudge {...this.props} /> }
        </CompanyAppBar>

        <CompanyGridList items={this.props.companies}
          click={this.props.companyClicked}
          chatClick={this.props.companyChatClicked}
        />

      </Box>);
  }
}

const mapStateToProps = state => {
  return {
    event: state.event,
    eventTitle: state.event.data.title,
    eventSubtitle: state.event.data.subtitle,
    companies: state.companies.items,
    logoURL: state.event.data.logo ? state.event.data.logo.url : false,
    headerURL: state.event.data.background ? state.event.data.background.header.url : false,
    profile: state.profile.data,
    resumePresent: state.profile.data && state.profile.data.resume && state.profile.data.resume.url,
    accountDialogOpen: state.company.accountDialogOpen,
    initialValues: state.profile.data,
    profileInProgress: state.profile.inProgress,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setEventId: (eventId) => {
      return dispatch(EventActions.setEventId(eventId));
    },
    checkIn: (eventId) => {
      console.log("check in");
      return dispatch(EventActions.checkIn(eventId));
    },
    companyClicked: (slug) => {
      console.log("company card click ", slug);
      return dispatch(EventActions.companySelected(slug));
    },
    companyChatClicked: (slug) => {
      console.log("company chat click", slug);
      return dispatch(EventActions.companySelectedChatNow(slug));
    },
    loadProfile: async () => dispatch(ProfileActions.fetchProfile()),
    logout: () => {
      return dispatch(CompanyActions.logout());
    },
    showMyAccount: () => {
      dispatch(CompanyActions.openMyAccount());
    },
    hideMyAccount: () => {
      dispatch(CompanyActions.closeMyAccount());
    },
    saveAccountDialog: () => {
      dispatch( submit('profile') );
    },
    submitAccountDialog: async (values) => {
      await dispatch(ProfileActions.submitProfile());
      dispatch(CompanyActions.closeMyAccount());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LobbyPage);
